import type { AgentMetricsSnapshot } from "../utils/types";

type OverviewStatCardsProps = {
  metrics: AgentMetricsSnapshot | null;
};

type StatCard = {
  label: string;
  value: string;
  accent?: string;
};

const formatLatency = (value: number | null | undefined) => {
  if (value == null) return "—";

  if (value < 1000) return `${Math.round(value)}ms`;

  return `${(value / 1000).toFixed(1)}s`;
};

const formatPercent = (rate: number) => `${(rate * 100).toFixed(1)}%`;

const formatTokens = (value: number | null | undefined) => {
  if (value == null) return "—";

  return `~${Math.round(value).toLocaleString()} tok`;
};

const successColor = (rate: number) => {
  if (rate >= 0.95) return "var(--chart-green)";
  if (rate >= 0.85) return "#eab308";

  return "var(--chart-red)";
};

export const OverviewStatCards = ({ metrics }: OverviewStatCardsProps) => {
  const successRate = metrics?.successRate ?? 1;

  const cards: StatCard[] = [
    { label: "Active runs", value: String(metrics?.activeRuns ?? 0) },
    { label: "Success rate", value: formatPercent(successRate), accent: successColor(successRate) },
    { label: "Avg context in", value: formatTokens(metrics?.avgContextTokensEst) },
    { label: "Completed", value: String(metrics?.statusCounts.completed ?? 0) },
    { label: "Failed", value: String(metrics?.statusCounts.failed ?? 0) },
    { label: "Runs / hour", value: metrics ? metrics.runsPerHour.toFixed(1) : "—" },
    { label: "Avg latency", value: formatLatency(metrics?.latency.avgMs) },
    { label: "Tool calls", value: String(metrics?.toolCalls.total ?? 0) },
  ];

  return (
    <div className="admin-stat-row">
      {cards.map((card) => (
        <div key={card.label} className="admin-stat-card">
          <span className="admin-stat-label">{card.label}</span>
          <span
            className="admin-stat-value"
            style={card.accent ? { color: card.accent } : undefined}
          >
            {card.value}
          </span>
        </div>
      ))}
    </div>
  );
};
